import React from 'react';
import clsx from 'clsx';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import CardMui from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

const useStyles = makeStyles({
   root: {
      minWidth: 275
   }
});

function Card(props) {
   const classes = useStyles();
   const {registro, children, className, xs, ...other} = props;
   return (
      <Grid container item xs={xs || 3} {...other}>
         <CardMui className={clsx(classes.root, className)}>
            <CardContent>
               <Grid container item xs={12}>
                  {children}
               </Grid>
            </CardContent>
         </CardMui>
      </Grid>
   );
}

export default Card;
